import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { ModalTest } from './ModalTest';


export class ModalInput extends Component {

    constructor(props) {
        super(props);
        this.state = { show: false };
      }

      toggleIsActive = () => {
        this.setState({ show: !this.state.show })
      };

      close(){
        this.setState({ show: false });
      };

      

    render() {
        return(
        <>
          <Button onClick={this.toggleIsActive}>ggggg</Button>
          <ModalTest show={this.state.show} toggleModal={this.toggleIsActive} />
        </>
        )
    }
}